module.exports = __webpack_public_path__ + "media/application/images/ui/external-links-cc5a69d19bcb7966d9e2acc1556d2811.png";